// Static catalog backing the composer type-ahead. v1 is a curated, in-bundle
// list — instant, no backend, no per-keystroke cost — and `matchQuestions` is
// the single swap point if an LLM completions source is added later.
//
// Intentionally GENERIC analyst questions: no tenant store numbers, ids, or
// eval-derived phrasing (the substrate must never overfit to the eval set).
export const QUESTION_CATALOG: string[] = [
  "Give me an overview of the portfolio",
  "Compare stores by survey completion",
  "Which stores are missing photos?",
  "Show me incomplete nameplate data",
  "How many stores have been surveyed?",
  "Which stores have the most open issues?",
  "Summarize asset condition across the portfolio",
  "Which assets are missing manufacturer data?",
  "Break down survey completion by store",
  "Show me the stores with the lowest data quality",
  "What equipment is nearing end of life?",
  "List stores by number of assets",
  "Compare nameplate coverage across stores",
  "Which stores need a follow-up visit?",
  "Show me assets without a captured nameplate",
  "What is the average answered-question rate per store?",
  "Highlight stores with missing survey sections",
  "Which manufacturers appear most across the portfolio?",
  "Show me a breakdown of asset types",
  "Where is photo coverage weakest?",
];

/**
 * Case-insensitive completion match against the catalog. Prefix matches rank
 * above substring matches; a draft that already equals a catalog entry is
 * excluded (nothing left to complete). Returns at most `limit` suggestions.
 */
export function matchQuestions(query: string, limit = 6): string[] {
  const q = query.trim().toLowerCase();
  if (q.length < 2) return [];
  const prefix: string[] = [];
  const substring: string[] = [];
  for (const item of QUESTION_CATALOG) {
    const lower = item.toLowerCase();
    if (lower === q) continue;
    if (lower.startsWith(q)) prefix.push(item);
    else if (lower.includes(q)) substring.push(item);
  }
  return [...prefix, ...substring].slice(0, limit);
}
